<template>
  <ViewWrapper headingText="Merchants">
    <Merchants></Merchants>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '@/components/ViewWrapper'
import Merchants from '@/components/manage/Merchants'

export default {
  components: { ViewWrapper, Merchants }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/MerchantsPage.vue